import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import {
  routeHelpersWorkLogsPayerToApprove,
  routeHelpersWorkLogPayerDetails
} from "../../../../WorkLogs/paths";
import { NotificationTemplate } from "../index";
import { WorkLogSubmittedForReviewNotificationContext } from "../types";

export type WorkLogSubmittedForReviewPayerContext =
  WorkLogSubmittedForReviewNotificationContext;

// Keeping the group threshold as 2 for now, can be adjusted later
const GROUP_THRESHOLD = 2;

export const WorkLogSubmittedForReviewPayer: NotificationTemplate<WorkLogSubmittedForReviewPayerContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Work logs awaiting review"
        : "Work log awaiting review",
    renderBody: props => {
      if (props.group.length >= GROUP_THRESHOLD) {
        return `${props.group.length} work logs are awaiting your review.`;
      }
      return `Work log #${props.context.workLogNumber} from ${props.context.payeeName} is awaiting your review.`;
    },
    Footer: props => {
      const history = useHistory();
      const goToWorkLogPayerDetails = routeHelpersWorkLogPayerDetails.useGoTo();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              history.push(routeHelpersWorkLogsPayerToApprove.path);
            }}
          >
            Review work logs
          </WSButton.Link>
        );
      }

      return (
        <WSButton.Link
          size="S"
          rightIcon="chevron-right"
          onClick={() => {
            goToWorkLogPayerDetails({ workLogId: props.context.workLogId });
          }}
        >
          Review work log
        </WSButton.Link>
      );
    }
  };
